   // my finded code 
import React, { useEffect } from 'react';
import { Routes, Route, useLocation} from 'react-router-dom';
import "bootstrap/dist/css/bootstrap.min.css";
import Header from './Header';
import Footer from './Footer';
import GetinTouch from './component/GetinTouch';
import Home from './Home';
import Course from './component/Course';
import About from './component/About';
import Blogdetail from './component/Blogdetail';
import Blog from './component/Blog';
import Coursedetail from './component/Coursedetail';
// import { initializeJQueryPlugins } from './component/Jqueryinitializer';
import ScrollToTop from './component/Helper';
import BackgroundUpdater from './component/Setbackground';
// import MobileMenu from './component/mobilemenu';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Instracter from './component/Instracter-detail';
import Cartpage from './Cartpage';
import Checkout from './component/Checkout';
import Our_Instructors from './component/Our_Instructors';
import Placmant from './component/Placmant';
import NotFound from './component/NotFound';
import Profail from './component/Profail';
import PlaceOrderSuccess from './component/Placeorder';
import MainLayout from './Layout/MainLayout';
import { privateRoutes, publicRoutes } from './routes/Routes_Config';
import PrivateRoute from './component/privateRoute/PrivateRoute';
function App() {
   
  const location = useLocation();
  useEffect(() => {
    // Set background image from data-bg-src
    const bgSrcElements = document.querySelectorAll('[data-bg-src]');
    bgSrcElements.forEach((element) => {
      const src = element.getAttribute('data-bg-src');
      if (src) {
        element.style.backgroundImage = `url(${src})`;
        element.classList.add('background-image');
        element.removeAttribute('data-bg-src');
      }
    });

    // Set background color from data-bg-color
    const bgColorElements = document.querySelectorAll('[data-bg-color]');
    bgColorElements.forEach((element) => {
      const color = element.getAttribute('data-bg-color');
      if (color) {
        element.style.backgroundColor = color;
        element.removeAttribute('data-bg-color');
      }
    });

    // Set mask image from data-mask-src
    const maskSrcElements = document.querySelectorAll('[data-mask-src]');
    maskSrcElements.forEach((element) => {
      const mask = element.getAttribute('data-mask-src');
      if (mask) {
        element.style.maskImage = `url(${mask})`;
        element.style.WebkitMaskImage = `url(${mask})`;
        element.classList.add('bg-mask');
        element.removeAttribute('data-mask-src');
      }
    });
  },[location.pathname]); 

 
  return (
    <> 
    {/* <ScrollToTop/>
    <BackgroundUpdater/>
      <Header /> 
      */}
      <Routes>
        <Route element={<MainLayout/>}>
        {/* <Route path="/" element={<Home />} />
        <Route path="/contact" element={<GetinTouch />} />
        <Route path="/course" element={<Course />} />
        <Route path="/about" element={<About />} />
        <Route path="/blogdetail/:slug" element={<Blogdetail />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/course-detail/:id" element={<Coursedetail />} />
        <Route path="/team-detail/:slug" element={<Instracter />} />
        <Route path="/ourinstructer" element={<Our_Instructors />} />
        <Route path="/Placmant" element={<Placmant />}/>
        <Route path="*" element={<NotFound />} />
        <Route path="/placeorder" element={<PlaceOrderSuccess />} /> */}
        {
          publicRoutes.map(({path, element},index)=>(
             <Route key={index} path={path} element={element} />
          ))}

       {privateRoutes.map(({ path, element }, i) => (
        <Route key={`private-${i}`} path={path} element={element} />
      ))}
       </Route>
      </Routes>
       
           

{/* 
        <Route path='/profail'element={<Profail/>}/>
        <Route path="/cartpage"element={<Cartpage/>}/>
        <Route path='/checkout'element={<Checkout/>}/> */}

      {/* <Footer /> */}
      
      {/* <MobileMenu/> */}
    </>
  );
}

export default App;

   
